/**
 * Cumple Sprint 16 — Cliente API para actas de reunión ISO 19011.
 */
import { apiRequest } from './client.js';

export type MeetingKind = 'opening' | 'closing';

export interface Attendee {
  name: string;
  role: string;
  organization?: string;
}

export interface AuditMeetingRecord {
  id: string;
  assessment_id: string;
  kind: MeetingKind;
  attendees: Attendee[];
  agenda: string | null;
  notes: string | null;
  held_at: string;
  created_at: string;
  created_by_user_id: string;
}

export interface UpsertMeetingInput {
  attendees: Attendee[];
  agenda?: string | null;
  notes?: string | null;
  held_at: string;
}

export const auditMeetingsApi = {
  list: (assessmentId: string) =>
    apiRequest<{ meetings: AuditMeetingRecord[] }>(`/api/v1/assessments/${assessmentId}/meetings`),
  upsert: (assessmentId: string, kind: MeetingKind, input: UpsertMeetingInput) =>
    apiRequest<{ meeting: AuditMeetingRecord }>(
      `/api/v1/assessments/${assessmentId}/meetings/${kind}`,
      { method: 'PUT', body: input },
    ),
};
